import { apiV2 } from '@newtontechnologies/beey-api-js-client/endpoints';
import { json } from '@newtontechnologies/beey-api-js-client/receivers';
export const parseApiSpeakerSuggestions = (rawData) => {
    return JSON.parse(rawData);
};
export const convertSuggestedSpeakers = (rawData) => rawData.map((item) => ({
    speaker: {
        neutralData: {
            uniqueId: item.Speaker.NeutralData.UniqueId,
            defaultLocalisation: item.Speaker.NeutralData.DefaultLocalisation,
            customData: item.Speaker.NeutralData.CustomData,
            imageBase64: item.Speaker.NeutralData.ImageBase64,
            pairedSpeakers: item.Speaker.NeutralData.PairedSpeakers,
            lastEditorId: item.Speaker.NeutralData.LastEditorId,
            lastEdited: item.Speaker.NeutralData.LastEdited,
        },
        localizations: Object.fromEntries(Object.entries(item.Speaker.Localizations).map(([locale, loc]) => [
            locale,
            {
                speakerIdActive: loc.SpeakerIdActive,
                defaultVariantIndex: loc.DefaultVariantIndex,
                nameVariants: loc.NameVariants.map((v) => ({
                    firstName: v.FirstName,
                    lastName: v.LastName,
                    roles: v.Roles,
                    defaultRoleIndex: v.DefaultRoleIndex,
                })),
            },
        ])),
        concurrencyToken: item.Speaker.ConcurrencyToken,
    },
    variantPaths: item.VariantPaths,
}));
export const addSpeaker = async (connection, body) => connection.fetch()
    .url(apiV2.speakersV2.url())
    .postJson(body)
    .receive(json()
    .finally(() => 'unexpected'))
    .fetchStrict();
export const fetchSpeaker = async (connection, speakerId) => connection.fetch()
    .url(apiV2.speakersV2.uniqueId(speakerId).url())
    .receive(json()
    .finally(() => 'unexpected'))
    .fetchStrict();
export const fetchSpeakerHistory = async (connection, speakerId) => connection.fetch()
    .url(apiV2.speakersV2.uniqueId(speakerId).history.url())
    .receive(json()
    .finally(() => 'unexpected'))
    .fetchStrict();
export const fetchDuplicateSpeakers = async (connection, speaker) => {
    var _a, _b;
    const params = {
        firstName: (_a = speaker.firstName) !== null && _a !== void 0 ? _a : null,
        lastName: speaker.lastName,
        localization: (_b = speaker.localization) !== null && _b !== void 0 ? _b : null,
    };
    return connection.fetch()
        .url(apiV2.speakersV2.duplicates.url(params))
        .receive(json()
        .finally(() => 'unexpected'))
        .fetchStrict();
};
export const updateSpeaker = async (connection, uniqueId, body) => connection.fetch()
    .url(apiV2.speakersV2.uniqueId(uniqueId).url())
    .putJson(body)
    .receive(json()
    .finally(() => 'unexpected'))
    .fetchStrict();
export const deleteSpeaker = async (connection, speakerId) => connection.fetch()
    .url(apiV2.speakersV2.uniqueId(speakerId).url())
    .delete()
    .receive(json()
    .finally(() => 'unexpected'))
    .fetchStrict();
export const listSpeakers = async (connection, skip, count, localizations, searchQuery, lastChangeFrom, lastChangeTo, isSpeakerIdActive, orderBy, sortOrder) => connection.fetch()
    .url(apiV2.speakersV2.filteredSuggest.url({
    skip,
    count,
    localizations,
    searchQuery,
    lastChangeFrom,
    lastChangeTo,
    isSpeakerIdActive,
    orderBy,
    sortOrder,
}))
    .receive(json()
    .finally(() => 'unexpected'))
    .fetchStrict();
export const mergeSpeakers = async (connection, body) => connection.fetch()
    .url(apiV2.speakersV2.merge.url())
    .postJson(body)
    .receive(json()
    .finally(() => 'unexpected'))
    .fetchStrict();
